var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"mtb"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumbList),function(item,index){return _c('el-breadcrumb-item',{key:item.path},[(index === _vm.breadcrumbList.length - 1)?_c('span',[_vm._v(_vm._s(_vm.TLang(item.meta.crumbtitle, "my")))]):_c('span',{on:{"click":() => {
            _vm.$router.replace(item.path || '/');
          }}},[_vm._v(_vm._s(_vm.TLang(item.meta.crumbtitle, "my")))])])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }